import React from 'react';
import ComingSoonWrap from '../../meta/ComingSoon';

const TryhardMerchNotice: React.FC = () => {
    return (
        <div className='w-full h-96 flex flex-col justify-center items-center gap-y-4 text-white bg-red-950'>
            <h2 className='text-teko italic text-3xl font-semibold max-w-72 sm:max-w-none'>GET NOTIFIED WHEN OUR LATEST MERCH DROPS</h2>
            <p className='text-xl'>Subscribe and stay stocked!</p>
            <ComingSoonWrap>
                <button type='button' className='bg-white text-teko text-3xl font-semibold p-2 text-red-600'>Subscribe</button>
            </ComingSoonWrap>
        </div>
    )
}

export default TryhardMerchNotice;